'use strict';

var notificationHelpers = require('../common/notifications');
var inStore = require('./inStore');

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#inStoreLocatorDrawer').length !== 0) {
        $('#inStoreLocatorDrawer').remove();
    }
    const htmlString = '<!-- Modal -->'
        + '<div class="modal right fade" id="inStoreLocatorDrawer" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="inStoreLocatorDrawerTitle">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <h2 id="inStoreLocatorDrawerTitle" class="sr-only"></h2>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';

    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.in-store');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for popup book address.
 * @param {string} url - url to be used to retrieve store locator drawer elements
 */
function fillOutDrawerElements(url) {
    $.spinner().start();
    var drawer = $('#inStoreLocatorDrawer');
    $.ajax({
        url: url,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            const parsedHtml = parseHtml(data.renderedTemplate);
            drawer.find('.modal-body').empty().html(parsedHtml.body);
            drawer.find('.modal-footer').html(parsedHtml.footer);
            drawer.find('.modal-header .close .sr-only').text(data.closeButtonText);
            drawer.find('.enter-message').text(data.enterDialogMessage);

            $('#inStoreLocatorDrawerTitle').text(data.drawerTitle);

            const changeStoreText = $('.m-stock-in-stock__store .btn-change-store').text();
            if (changeStoreText) {
                $('#inStoreLocatorDrawerTitle').text(changeStoreText);
            }

            drawer.modal('show');

            const storeLocatorTemplates = $(parsedHtml.body).find('.all-stores-locator-templates');
            initStoreLocator(storeLocatorTemplates);

            $.spinner().stop();
        },
        error: function (err) {
            $.spinner().stop();
            drawer.modal('hide');
            if (err.responseJSON) {
                notificationHelpers.createErrorNotification(err.responseJSON.errorMessage);
            }
        }
    });
}

/**
 * Init Store locator for in store drawer
 * @param {jQuery} templates handlebars templates for jquery store locator plugin
 */
function initStoreLocator(templates) {
    var url = $('#nearestStoreUrl').val();
    const decodedUrl = atob(url);

    inStore.methods.loadAllNearestStores(decodedUrl, templates);
}

$('.btn-change-store').on('click', function (e) {
    e.preventDefault();
    getModalHtmlElement();
    var url = $(this).attr('href');
    const decodedUrl = atob(url);

    fillOutDrawerElements(decodedUrl);
});

$('body').on('storedrawer:reinit', function () {
    $('.btn-change-store').off('click').on('click', function (e) {
        e.preventDefault();
        getModalHtmlElement();
        var url = $(this).attr('href');
        const decodedUrl = atob(url);

        fillOutDrawerElements(decodedUrl);
    });
});

$('body').on('shown.bs.modal', '#inStoreLocatorDrawer', function () {
    $('#inStoreLocatorDrawer .close').focus();
});

$('body').on('hidden.bs.modal', '#inStoreLocatorDrawer', function () {
    $('.btn-change-store').focus();
});
